<p-panel header="Immediate Contact Details">
  <form [formGroup]="form">
    @if (loading) {
      <p-progressSpinner></p-progressSpinner>
    }

    @if (!loading) {
      <div>
        <div class="mb-4 md:col-span-12 p-0">
          <p>{{ panelDescription }}</p>
        </div>
        <div class="grid grid-cols-12 gap-4 p-fluid p-form-widget">
          <div class="col-span-12 md:col-span-6">
            <div class="field">
              <label [class.field-required]="isExternal">
                Contact's Name:
              </label>
              <div class="p-field-value">
                <input
                  type="text"
                  pInputText
                  trimInputValue
                  formControlName="contactName"
                  data-test-id="immediate-name-input"
                  (input)="addMaxLengthValidator()"
                  />
                  <errors-messages [control]="form.get('contactName')">
                  </errors-messages>
                </div>
              </div>
            </div>
            <div class="col-span-12 md:col-span-6">
              <div class="field">
                <label [class.field-required]="isExternal">
                  Contact's Phone:
                </label>
                <div class="p-field-value">
                  <p-input-mask
                    mask="(999) 999-9999"
                    formControlName="contactPhone"
                    [unmask]="true"
                    [autoClear]="false"
                    data-test-id="immediate-phone-input"
                  ></p-input-mask>
                  <errors-messages [control]="form.get('contactPhone')">
                  </errors-messages>
                </div>
              </div>
            </div>
            <div class="col-span-12 md:col-span-6">
              <div class="field">
                <label [class.field-required]="isExternal">Contact's Fax:</label>
                <div class="p-field-value">
                  <p-input-mask
                    mask="(999) 999-9999"
                    formControlName="contactFax"
                    [unmask]="true"
                    [autoClear]="false"
                    data-test-id="immediate-fax-input"
                  ></p-input-mask>
                  <errors-messages [control]="form.get('contactFax')">
                  </errors-messages>
                </div>
              </div>
            </div>
            <div class="col-span-12 md:col-span-6">
              <div class="field">
                <label>Contact's Phone Extension:</label>
                <div class="p-field-value">
                  <input
                    type="text"
                    pInputText
                    trimInputValue
                    formControlName="contactPhoneExtension"
                    data-test-id="immediate-phone-extension-input"
                    />
                    @if (form.controls['contactPhoneExtension'].hasError('maxlength')) {
                      <small class="p-error">
                        Must be up to 9 characters long
                      </small>
                    }
                  </div>
                </div>
              </div>
            </div>
            <p-message
              severity="warn"
              text="Fax numbers submitted here will be used to send PHI, authorizations, and clinical requests."
            ></p-message>
          </div>
        }
      </form>
    </p-panel>
